import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { usePermission } from "@js/apps/common/hooks";
import { useIsNodeOrImpersonated } from "@js/apps/common/hooks/use-is-node-or-impersonated";
import { useGetManagedEmployerQuery } from "@js/apps/employer/hooks";
import {
  findCurrentNavItem,
  getNavMenuColorVariant,
} from "@js/layouts/app/utils/common-navigation";
import { getEmployerNavItems } from "@js/layouts/app/utils/employer-navigation";

export const useEmployerSidebar = () => {
  const { pathname } = useLocation();
  const { data: employer } = useGetManagedEmployerQuery();
  const canViewInvoices = usePermission(
    ENUMS.CustomPermission.CAN_VIEW_EMPLOYER_INVOICES,
  );
  const isNodeStaffOrImpersonated = useIsNodeOrImpersonated();

  const employerNavItems = useMemo(() => {
    if (!employer) {
      return [];
    }

    return getEmployerNavItems({
      canViewInvoices,
      employer,
      isNodeStaffOrImpersonated,
    });
  }, [canViewInvoices, employer, isNodeStaffOrImpersonated]);

  const currentLinkVariant = useMemo(() => {
    const currentLinkItem = findCurrentNavItem({
      items: employerNavItems,
      exact: true,
      pathname,
    });

    return getNavMenuColorVariant(currentLinkItem, pathname);
  }, [employerNavItems, pathname]);

  return {
    sidebarItems: employerNavItems,
    itemVariant: currentLinkVariant,
  };
};
